import { render } from "./Prize.vue?vue&type=template&id=791cb73a&ts=true&lang=pug"
import script from "./Prize.vue?vue&type=script&lang=ts"
export * from "./Prize.vue?vue&type=script&lang=ts"

import "./Prize.vue?vue&type=style&index=0&id=791cb73a&lang=stylus"

import exportComponent from "/builds/CarrefourOneAPP/website/game/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__